module.exports = __webpack_public_path__ + "img/image-style-08.1c57c052.svg";